<script setup lang="ts">
import { TabStrip } from '@taler/ui'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { RouterLink, useRoute } from 'vue-router'

const { t } = useI18n()
const route = useRoute()

const activeName = computed(() => {
  const name = typeof route.name === 'string' ? route.name : undefined
  if (name === 'forecast' || name === 'forecast-scenario') return 'forecast'
  return 'targets'
})

const tabs = computed(() => [
  { to: { name: 'targets' }, label: t('targets.title'), active: activeName.value === 'targets' },
  { to: { name: 'forecast' }, label: t('forecast.title'), active: activeName.value === 'forecast' },
])
</script>

<template>
  <TabStrip :tabs="tabs" :ariaLabel="t('planning.title')" :as="RouterLink" />
</template>
